// extracted by mini-css-extract-plugin
module.exports = {"image-link":"image-link_image-link__LWhsd","image-link__image":"image-link_image-link__image__CoHvB","image-link__content":"image-link_image-link__content__yGU8L"};